export default { logMessage: 'a1e2328' };
